import React, { createContext, useEffect, useState } from "react";
import {
  EventOnControlChangeInputType,
  RequestScreenContextType,
  TableAStateType,
  TableBStateType,
} from "../types/RequestScreenContext.type";
import { flatAdvanceForm } from "../../../helpers/advance-form.helper";
import _ from "lodash";

export const RequestScreenContext = createContext<
  RequestScreenContextType | undefined
>(undefined);

export function Form27RequestScreenContextProvider(props: {
  templateId: number;
  children: React.ReactNode;
}) {
  const TEMPLATE_ID = [27, 67];
  const TABLE_NAME_A = "รายการสินค้า";
  const TABLE_NAME_B = "ข้อมูลใบวางบิลสำหรับใช้ออกงบใบสำคัญ";

  if (!TEMPLATE_ID.includes(props.templateId)) {
    // nothing todo
    return <>{props.children}</>;
  }

  const [tableA, setTableA] = useState<TableAStateType>({});
  const [tableB, setTableB] = useState<TableBStateType>({});
  const [memoId, setMemoId] = useState<any[]>([]);
  const [form, setForm] = useState<any>({});
  const [hasUpdate, setHasUpdate] = useState(false);
  const [tempId, setTempId] = useState(props.templateId);
  useEffect(() => {
      sessionStorage.removeItem("form27TableA");
      sessionStorage.removeItem("form27TableB");
      sessionStorage.removeItem("setHasUpdate2");
      sessionStorage.removeItem("ก่อนปรับมูลค่า");
      sessionStorage.removeItem("แถวที่ปรับ");
      sessionStorage.removeItem("ก่อนแถวที่ปรับ");
      sessionStorage.removeItem("ปรับมูลค่า");
      sessionStorage.removeItem("notFirst");
  }, []);

  function onControlChange(event: EventOnControlChangeInputType) {
    sessionStorage.removeItem("setHasUpdate2")
    if (event.controlTemplate.label === 'ปรับมูลค่า') {
      try {

        const controls = flatAdvanceForm(event.newControl);
        const control = controls.find(
          (t) => t?.template?.label == TABLE_NAME_B && t?.template?.type == "tb"
        );

        if (!control) {
          return event;
        }
        const tableData = serializeTbRowToObject(
          control?.data?.row,
          control?.template?.attribute?.column || []
        );
        sessionStorage.setItem("setHasUpdate2", "true")
        sessionStorage.setItem("ปรับมูลค่า", event.controlValue)


        let maxValue = 0;
        tableData.forEach((el: any, rowIdx: number) => {
          const value = parseFloat(el.จำนวนเงิน) || 0;
          if (value > maxValue) {
            maxValue = value;
            sessionStorage.setItem("setHasUpdate2", "true")
            sessionStorage.setItem("แถวที่ปรับ" , rowIdx.toString());
          }
        });

        const beforeValue = Number(sessionStorage.getItem("ก่อนปรับมูลค่า")) || 0;
        tableData.forEach((el: any , rowIdx:number) => {
          const value = parseFloat(el.จำนวนเงิน) || 0;
          if (value === maxValue) {
            const controlValue = parseFloat(event.controlValue) || 0
            el.จำนวนเงิน = (Number(el.จำนวนเงิน.toString().replaceAll(",", "").toString()) - beforeValue) + controlValue;
            el.จำนวนมูลค่าที่ปรับ = controlValue;
            sessionStorage.setItem("ก่อนปรับมูลค่า" ,controlValue.toString());
          }
        });

        setTableB((prv) => ({
          ...prv,
          data: tableData,
        }));
        setHasUpdate(true);
        sessionStorage.setItem("notFirst", "true");
      } catch (e) {
        console.error(Form27RequestScreenContextProvider.name, e);
      }
    } else if (event.isInTable && event.controlTemplate.label == TABLE_NAME_A) {
      try {
        const controls = flatAdvanceForm(event.newControl);
        const control = controls.find(
          (t) => t?.template?.label == TABLE_NAME_A && t?.template?.type == "tb"
        );
        if (!control) {
          return event;
        }
        const tableData = serializeTbRowToObject(
          control?.data?.row,
          control?.template?.attribute?.column || []
        );
        const toBeUpdate = isUpdateTableAData(tableData);
        if (toBeUpdate) {
          setTableA((prv) => ({
            ...prv,
            data: tableData,
            raw: control?.custom?.raw,
          }));

          setHasUpdate(true);
        }
      } catch (e) {
        console.error(Form27RequestScreenContextProvider.name, e);
      }
    }

    // if (event.isInTable && event.controlTemplate.label == TABLE_NAME_B) {
    //   try {
    //     const controls = flatAdvanceForm(event.newControl);
    //     const control = controls.find(
    //       (t) => t?.template?.label == TABLE_NAME_B && t?.template?.type == "tb"
    //     );
    //     if (!control) {
    //       return;
    //     }
    //     const tableData = serializeTbRowToObject(
    //       control?.data?.row,
    //       control?.template?.attribute?.column || []
    //     );
    //     setTableB((prv) => ({
    //       ...prv,
    //       data: tableData,
    //       objects: control?.data?.objects,
    //     }));
    //   } catch (e) {
    //     console.error(Form27RequestScreenContextProvider.name, e);
    //   }
    // }

    if (
      !event.isInTable &&
      ["ประเภทใบสำคัญ", "เลขที่ใบสำคัญ"].includes(event.controlTemplate.label)
    ) {
      setForm((prv: any) => ({
        ...prv,
        [event.controlTemplate.label]: event.controlValue,
      }));
    }
    return event;
  }

  function serializeTbRowToObject(
    rows: { value?: string }[][],
    columns: { label: string; control: any }[]
  ) {
    const result = rows.map((row, rindex) => {
      const columnObj = columns.map((column, cindex) => ({
        [column.label]: row[cindex].value,
      }));
      return Object.assign({}, ...columnObj);
    });
    return result;
  }

  function isUpdateTableAData(data: { [name: string]: string | null }[]) {
    const strData = JSON.stringify(data);
    const strTableA = JSON.stringify(tableA.data);
    return strData != strTableA;
  }

  const setMemoRefs =(id :any[])=>{
    setMemoId(id)
  }
  return (
    <RequestScreenContext.Provider
      value={{
        onControlChange,
        tableA,
        tableB,
        form,
        hasUpdate,
        setHasUpdate,
        tempId,
        memoId,
        setMemoRefs
      }}
    >
      {props.children}
    </RequestScreenContext.Provider>
  );
}
